module.exports = __webpack_public_path__ + "img/m-wash3-front.a46074fd.jpg";